define('lib/view/UnwrapBehavior',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    return Marionette.Behavior.extend({

        onRender: function() {
            this.view.$el = this.view.$el.children();
            this.view.$el.unwrap();

            this.view.setElement(this.view.$el);
        }

    });

});
